// Constants

export const liquidacion_deducidos = () => {
    return {
        liquidacion_deducidos: {
            id: {
                namepath: ["afiliado_liquidacion"],
                description: 'id autoincrement',
                label: 'Id',
                name: 'solId',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: ''
                }
            },
            id_info_liquidacion: {
                namepath: ["afiliado_liquidacion"],
                type: 'text',
                label: 'afiliado',
                name: 'solRazon',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    basico: true,
                    type: 'select',
                    disabled: false,
                    predeterminate: '',
                    list: 'list_razon',
                    label: 'label'
                },
            },
            concepto: {
                type: "text",
                label: "Gastos Menores",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            valor: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "$",
                }
            },
            predeterminado: {
                type: "number",
                label: "Valor",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "",
                }
            },
        }
    }
}